import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';

export const ToolbarWrapper = styled(Toolbar)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',

  [theme.breakpoints.up('sm')]: {
    paddingInline: 0,
    minHeight: 0,
  },
}));
